const { loadScripts } = Mobi2Go.helpers;

const TURNSTILE_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js';

export async function turnstileWidgetRemove (widget_element_id) {
    window.turnstile.remove('#' + widget_element_id)
};

export async function turnstileWidgetRender (site_key, widget_element_id) {
    if (!window.turnstile) {
        await loadScripts([TURNSTILE_URL], true);
    }

    return new Promise((resolve, reject) => {
        window.turnstile.render('#' + widget_element_id, {
            "sitekey": site_key,
            "callback": (response) => resolve(response),
            "timeout-callback": () => reject("Timeout error"),
            "error-callback": () => reject("Network error"),
            "expired-callback": () => reject("Challenge expired")
        })
    });
};